import FormGroup from "features/shared/forms/components/FormGroup";
import {
  BindFieldFunction,
  ClearFormValuesFunction,
  FormErrors,
  SetValidationErrorFunction,
  SetValidationRuleFunction,
  ValidateFormFieldFunction,
} from "features/shared/forms/hooks/useForm";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { setSipoAccountValidations, validateSipo } from "./sipoAccountValidations";

type Props = {
  bindField: BindFieldFunction;
  setValidationRule: SetValidationRuleFunction;
  validateFormField: ValidateFormFieldFunction;
  setValidationError: SetValidationErrorFunction;
  clearFormValues: ClearFormValuesFunction;
  errors: FormErrors;
};

// TODO: pouzit v komponente SipoAccountDialog
const SipoAccountSubForm = ({
  bindField,
  setValidationRule,
  validateFormField,
  setValidationError,
  clearFormValues,
  errors,
}: Props) => {
  // translations
  const tLabels = useTranslation("payments\\payments").t;

  // side-effects
  useEffect(() => {
    // set default validations
    setSipoAccountValidations(setValidationRule);

    return () => {
      // before unmount component remove values and validations
      setSipoAccountValidations(setValidationRule, "remove");
      clearFormValues(["sipoNumber"]);
    };
  }, []);

  // handlers
  const sipoBlurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
    validateSipo(e.target.value, validateFormField, setValidationError);
  }

  // render
  return (
    <FormGroup
      labelText={tLabels("sipoAccountDialog.sipo")}
      validationError={errors["sipoNumber"] ?? undefined}
    >
      <input
        className="form-control"
        placeholder={tLabels("sipoAccountDialog.setSipo")}
        onBlur={sipoBlurHandler}
        {...bindField("sipoNumber")}
      />
    </FormGroup>
  );
};

export default SipoAccountSubForm;
